<template>
    <div id="emerge-page">
        <LandingBanner></LandingBanner>
        <InfoAlliances></InfoAlliances>
        <Emerge></Emerge>
        <HowItWorks></HowItWorks>
        <EmergeGoals></EmergeGoals>
        <AboutAlliance></AboutAlliance>
        <OportunityDescription></OportunityDescription>
        <EmergeEnd></EmergeEnd>
    </div>
</template>

<script>
import sal from 'sal.js';
import LandingBanner from '../../../components/landing-components/emerge-components/LandingBanner.vue';
import InfoAlliances from '../../../components/landing-components/emerge-components/AlliancesInformation.vue';
import Emerge from '../../../components/landing-components/emerge-components/Emerge.vue';
import HowItWorks from '../../../components/landing-components/emerge-components/HowItWorks.vue';
import EmergeGoals from '../../../components/landing-components/emerge-components/EmergeGoals.vue';
import AboutAlliance from '../../../components/landing-components/emerge-components/AboutAlliance.vue';
import OportunityDescription from '../../../components/landing-components/emerge-components/OportunityDescription.vue';
import EmergeEnd from '../../../components/landing-components/emerge-components/EmergeEnd.vue';
export default {
    name: "EmergePage",
    data: () => ({

    }),
    mounted() {
        sal();
    },
    components: {
    LandingBanner,
    InfoAlliances,
    Emerge,
    HowItWorks,
    EmergeGoals,
    AboutAlliance,
    OportunityDescription,
    EmergeEnd
}
}
</script>